import { render, staticRenderFns } from "./LoadingContainer.vue?vue&type=template&id=940c2b1a"
import script from "./LoadingContainer.vue?vue&type=script&lang=js"
export * from "./LoadingContainer.vue?vue&type=script&lang=js"
import style0 from "./LoadingContainer.vue?vue&type=style&index=0&id=940c2b1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports